<template>
  <div class="ist-card" v-on:click="cardClicked" :class="{ clickable: clickable() }">
    <ul class="ist-card__tabs">
      <li>
        <a href="#" name="tab1">&nbsp;&nbsp;</a>
      </li>
    </ul>
    <div class="ist-card__body" :style="minh">
      <div class="ist-card__toolbar" v-if="hasToolbarSlot">
        <q-toolbar class="text-primary ist-actionbar">
          <slot name="toolbar"></slot>
        </q-toolbar>
      </div>
      <q-icon class="iconstyle" :name="iconname" v-if="iconname" />
      <div class="ist-card__body__section">
        <slot></slot>
      </div>
      <div class="ist-card__splitter ist-card__move-to-bottom" v-if="pTags.length > 0"></div>
      <div class="ist-card__body__section" v-if="pTags.length > 0">
        <div class="ist-arrow-right_start">
          <div
            class="ist-arrow-right"
            v-for="tag in pTags"
            v-bind:key="tag.name"
            v-bind:style="[setArrowColor(tag.color)]"
            v-on:click="tagClicked(tag)"
            :class="{ clickable: clickable() }"
          >
            {{ tag.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { CardTags } from "./IstLayoutCard";
import { Vue, Prop, Watch, Emit } from "vue-property-decorator";

export default class App extends Vue {
  name = "ISTLayoutCard";

  @Prop()
  iconname!: string;
  @Prop({ default: "min-height: 180px" })
  minh!: string;
  @Prop({ default: "#f00000" })
  arrowcolor!: string;
  @Prop([Array])
  tags!: CardTags[] | null;

  pTags: CardTags[] = [];

  mounted() {
    this.pTags.length = 0;
    if (this.tags) {
      this.pTags = this.tags;
    }
  }

  @Watch("tags", {})
  onChangeTags(newtags: CardTags[]) {
    this.pTags = [];
    if (newtags) {
      this.pTags = newtags;
    }
  }

  @Emit("click")
  cardClicked(event) {
    this.$emit("click", event, this);
  }

  tagClicked(event) {
    this.$emit("tagclick", event, this);
  }

  setArrowColor(arraycolor?: string) {
    //console.log("setArrowColor", arraycolor, this.arrowcolor);
    return {
      "background-color": arraycolor ?? this.arrowcolor,
      "border-color": arraycolor ?? this.arrowcolor
    };
  }

  clickable() {
    const onRE = /^on[^a-z]/;
    const attributes = {};
    const listeners = {};
    const { $attrs } = this;

    for (const property in $attrs) {
      if (onRE.test(property)) {
        listeners[property] = $attrs[property];
      } else {
        attributes[property] = $attrs[property];
      }
    }
    return listeners["click"] != undefined;
  }

  get hasToolbarSlot() {
    return this.$slots["toolbar"];
  }
}
</script>

<style lang="scss">
@import "../assets/variables";
.ist-card {
  &__tabs {
    display: none;
    overflow: hidden;
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      float: left;
      margin: 0 0.5em 0 0;
    }

    a {
      position: relative;
      background: #f0ad4e;
      padding: 0.7em 3.5em;
      float: left;
      text-decoration: none;
      color: #444;
      margin-left: 30px;
    }

    a:hover,
    a:hover::after,
    a:focus,
    a:focus::after {
      background: #fff;
    }

    a:focus {
      outline: 0;
    }

    a::after {
      content: "";
      position: absolute;
      z-index: 1;
      top: 0;
      right: -0.5em;
      bottom: 0;
      width: 1em;
      background: #f0ad4e;
      transform: skew(10deg);
      border-radius: 0 5px 0 0;
    }

    a::before {
      content: "";
      position: absolute;
      z-index: 1;
      top: 0;
      left: -0.5em;
      bottom: 0;
      width: 1em;
      background: #f0ad4e;
      -webkit-transform: skew(10deg);
      transform: skew(-12deg);
      border-radius: 5px 0px 0 0;
    }
  }

  &__splitter {
    border-top: 1px solid #ddd;
    margin: 0 16px;
  }
  &__move-to-bottom {
    margin-top: auto;
  }

  &__toolbar {
    border-bottom: 2px solid #ddd;

    & .q-field--filled {
      & .q-field__control {
        background-color: #fafafa;
        border: none;
        border-radius: 0;
      }
    }
  }

  &__body {
    background: #ffffff;
    border-radius: 16px;
    vertical-align: top;
    position: relative;
    border: 1px solid #ddd;
    display: flex;
    flex-direction: column;

    & .footer {
      border-top: 1px solid #ddd;
      display: inline-block;
      position: relative;
      width: 100%;
      height: 30px;
    }

    & > div:first-child,
    & > img:first-child {
      border-top: 0;
      border-top-left-radius: inherit;
      border-top-right-radius: inherit;
    }
    & > div:last-child,
    & > img:last-child {
      border-bottom: 0;
      border-bottom-left-radius: inherit;
      border-bottom-right-radius: inherit;
    }
    & > div:not(:first-child),
    & > img:not(:first-child) {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
    & > div:not(:last-child),
    & > img:not(:last-child) {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    & > div {
      border-left: 0;
      border-right: 0;
      box-shadow: none;
    }

    @media screen and (min-width: 800px) {
      &__section {
        position: relative;
        padding: 16px;
        overflow: hidden;

        & > .q-table__card {
          border: 0 !important;
          border-radius: 0 !important;
          margin: 0 -16px -16px -16px;
        }
      }
    }

    @media screen and (max-width: 800px) {
      &__section {
        position: relative;
        padding: 0px;
        overflow: hidden;

        & > .q-table__card {
          border: 0 !important;
          border-radius: 0 !important;
          margin: 0 -16px 0px -16px;
        }
      }
    }
  }
}

.minicard .ist-card__body__section {
  padding: 16px;
}

.istcard {
  filter: drop-shadow(2px 2px 3px rgba(0, 0, 0, 0.12));
}

.ist-arrow-right_start {
  margin-left: -25px;
  margin-top: -8px;
}

.ist-arrow-right {
  padding: 6px 18px 06px 32px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  border: 1px solid transparent;
  color: #000;
  background-color: #f0ad4e;
  border-color: #f0ad4e;
  border-radius: 5px 2px 2px 5px !important;
  margin-top: 8px;
  float: left;
  position: relative;
  margin-right: 15px;
}

.ist-arrow-right::after {
  content: "";
  top: 4px;
  right: -11px;
  position: absolute;
  width: 24px;
  height: 24px;
  background: inherit;
  border-left-color: transparent;
  border-bottom-color: transparent;
  border-radius: 2px 5px 2px 20px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}
.iconstyle {
  text-align: center;
  font-size: 3em;
  width: 100%;
  padding-top: 8px;
  margin-left: 10px;
  font-size: xx-large !important;
}
.clickable .ist-card__body {
  cursor: pointer;
  -webkit-box-shadow: 2px 2px 5px -4px #000000;
  box-shadow: 2px 2px 5px -4px #000000;
}
.clickable:hover .ist-card__body {
  -webkit-box-shadow: 0px 0px 0px 0px #000000;
  box-shadow: 0px 0px 0px 0px #000000;
}
.ist-actionbar {
  flex-wrap: wrap !important;
}
</style>
